'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      hidden: false
    };

    _this.closeClicked = function () {
      _this.setState({
        hidden: true
      });
    };

    return _this;
  }

  _createClass(_default, [{
    key: "render",
    value: function render() {
      if (this.state.hidden) {
        return null;
      }

      var message = this.props.message;
      return /*#__PURE__*/_jsx("div", {
        className: "alert-message-container",
        children: /*#__PURE__*/_jsxs("div", {
          className: "alert-message",
          children: [/*#__PURE__*/_jsx("span", {
            className: "icon icon-cancel",
            onClick: this.closeClicked
          }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: message
          })]
        })
      });
    }
  }]);

  return _default;
}(React.Component);

_default.propTypes = {
  message: PropTypes.string
};
export { _default as default };